import {
    NinchatAcceptAudienceAction,
    NinchatActionType,
} from 'api/types/actions'
import ninchatClient, {
    NinchatActionParams,
} from 'api/NinchatClient'
import {NinchatChannelJoinedEvent} from 'api/types/events'
import {createAsyncThunk} from '@reduxjs/toolkit'
import {isVideoChannel} from 'utils/channels'
import {jitsiRequestAutoJoin} from 'actions/jitsi'
import {push} from 'navigation/actions'
import {startAppListening} from 'middlewares/listener'

const actionTypePrefix = 'NINCHAT/action'

export const acceptAudience = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatAcceptAudienceAction}`,
    async (arg: NinchatActionParams<NinchatAcceptAudienceAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatAcceptAudienceAction

        try {
            return await ninchatClient.send(params) as NinchatChannelJoinedEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)

const NAVIGATION_TIMEOUT_IN_MS = 5000

startAppListening({
    actionCreator: acceptAudience.fulfilled,
    effect: async (action, listenerApi) => {
        listenerApi.cancelActiveListeners()
        const {channel_id} = action.payload
        const state = listenerApi.getState()

        const isChannelInState = !!state.ninchat.user_channels[channel_id]
        const queueId = state.ninchat.user_channels[channel_id]?.channel_attrs?.queue_id

        if (isChannelInState || await listenerApi.condition((_, currentState) => !!currentState.ninchat.user_channels[channel_id], NAVIGATION_TIMEOUT_IN_MS)) {
            const queue = (queueId ? state.ninchat.user_queues?.[queueId] : undefined) ?? (queueId ? state.ninchat._queues?.[queueId] : undefined)
            const videoAutoJoinEnabled = queue?.queue_attrs?.video_autojoin === true
            const videoChannel = isVideoChannel(state.ninchat.user_channels[channel_id])

            if (videoChannel && videoAutoJoinEnabled) {
                // Mark channel for auto-join in jitsi
                listenerApi.dispatch(jitsiRequestAutoJoin(channel_id))
            }
            listenerApi.dispatch(push({
                name: 'Channel',
                params: {channel_id},
            }))
        }
    },
})
